import {
  IonText,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonDatetime,
  useIonToast,
  IonList,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import { useState, useEffect } from "react";
import { FileHolder } from "../../../@types/fileHolder";
import { useDispatch, useSelector } from "react-redux";
import { uploadDocument } from "../../../store/userShow/actions/uploadFile";
import { uploadFileCompliance } from "../../../store/userShow/actions/uploadFileCompliance";
import { selectDocumentCategory } from "../../../store/utils/selectors/selectDocumentCategory";

interface ComponentProps {
  userId: string;
  ownerId: string;
  isFrom: string;
}

const thisYear = new Date().getFullYear();
const limitYear = thisYear + 3;

export const UploadDocument: React.FC<ComponentProps> = ({ userId, ownerId, isFrom }) => {
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [fileHolder, setFileHolder] = useState<FileHolder[]>([]);
  const [presentToast, hideToast] = useIonToast();
  const [currentCategory, setCurrentCategory] = useState<string>("");
  const [hasExpirationDate, setHasExpirationDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const categories = useSelector(selectDocumentCategory);

  const dateParsedToPost = selectedDate?.replace(/T.*/, "").split("-").reverse().join("/");

  const onSelectFile = (e: any) => {
    const newFileHolder = [
      {
        file: e.target.files[0],
        id: parseInt(currentCategory),
        userId: userId,
        ownerId: ownerId,
        expirationDate: "",
      },
    ];
    setFileHolder(newFileHolder);
  };

  useEffect(() => {
    if (fileHolder.length > 0) {
      fileHolder[0].expirationDate = dateParsedToPost;
    }
  }, [selectedDate]);

  useEffect(() => {
    if (currentCategory != "") {
      const categoryHasExpirationDate = categories.filter((c) => c.id === currentCategory);
      if (categoryHasExpirationDate[0].datesRequire === true) {
        setHasExpirationDate(true);
        setSelectedDate("");
        setFileHolder([]);
      } else {
        setHasExpirationDate(false);
        setSelectedDate("");
        setFileHolder([]);
      }
    }
  }, [currentCategory]);

  const handleSendNotification = async (fileHolder: FileHolder[]) => {
    if (fileHolder.length === 0) {
      presentToast({
        message: " Debe Subir un Archivo antes de guardar",
        color: "danger",
        duration: 3000,
      });
    } else {
      try {
        await hideToast();
        presentToast({
          message: `Cargando Archivo...`,
          color: "primary",
        });
        let responseMessage = "";
        if (fileHolder.length > 0) {
          const { payload: notificationCreated }: any =
            (await dispatch(uploadDocument(fileHolder))) || {};
          if (!notificationCreated) {
            throw new Error("No se pudo cargar el archivo");
          } else {
            console.log(notificationCreated);
            responseMessage = "Se Cargo Correctamente el Archivo";
          }
        }
        await hideToast();
        presentToast({
          message: responseMessage,
          color: "success",
          duration: 8000,
        });
      } catch (error) {
        await hideToast();
        presentToast({
          message: "Ocurrió un problema al enviar el archivo",
          color: "danger",
          duration: 8000,
        });
      }
    }
  };

  return (
    <>
      <IonCard className="ion-margin-start">
        <IonLabel
          style={{
            justifyContent: "center",
            display: "flex",
            borderBottom:
              "1px solid var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
          }}
        >
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ justifyContent: "center", display: "flex" }}>
              <IonList style={{ width: "60%" }}>
                <IonItem style={{ width: "100%" }}>
                  <IonSelect
                    placeholder="Seleccione Categoría"
                    style={{ width: "100%", textAlign: "center" }}
                    onIonChange={(ev) => setCurrentCategory(ev.detail.value)}
                  >
                    {categories.map((category, index) => (
                      <IonSelectOption key={`item-${index}`} value={category.id}>
                        <IonText className="ion-text-wrap">{category.name}</IonText>
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>
              </IonList>
            </IonCol>
          </IonRow>
        </IonLabel>
        <IonItem>
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ textAlign: "center" }}>
              <IonButton color="primary" style={{ fontWeight: 300 }} size={"default"}>
                <label htmlFor="docButton" style={{ cursor: "pointer" }}>
                  <IonLabel>
                    <p style={{ fontWeight: 500 }}>SUBIR DOCUMENTO</p>
                  </IonLabel>
                </label>
              </IonButton>
              <input
                type="file"
                id="docButton"
                name="nombre documento"
                style={{ display: "none" }}
                onChange={(event) => onSelectFile(event)}
                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                required
              />
              <IonLabel>
                {fileHolder.length > 0 ? <p>{fileHolder[0].file.name}</p> : <p>Nombre Archivo</p>}
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonItem>
        {hasExpirationDate && (
          <IonItem>
            <IonRow style={{ width: "100%", padding: 20 }}>
              <IonCol style={{ textAlign: "center" }}>
                <IonLabel>
                  <IonDatetime
                    displayFormat="DD MMM, YYYY"
                    placeholder="Seleccione Fecha"
                    monthShortNames="Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto, Sept, Oct, Nov, Dic"
                    min={`${thisYear}`}
                    max={`${limitYear}`}
                    doneText="Aceptar"
                    cancelText="Cancelar"
                    value={selectedDate}
                    onIonChange={(e) => setSelectedDate(e.detail.value!)}
                  ></IonDatetime>
                </IonLabel>
                <IonLabel>
                  <p>Fecha de vencimiento</p>
                </IonLabel>
              </IonCol>
            </IonRow>
          </IonItem>
        )}
        <IonRow style={{ textAlign: "center", padding: 20 }}>
          <IonCol>
            <IonButton onClick={() => handleSendNotification(fileHolder)}>Guardar</IonButton>
          </IonCol>
        </IonRow>
      </IonCard>
    </>
  );
};
